import { useRef, useState } from 'react';
import { Button, Form, InputGroup, Spinner } from 'react-bootstrap';
import { api } from '../../lib/api';
import { useToast } from '../../context/ToastContext';

// Logo da empresa: envia um JPG/PNG/WEBP (limite de tamanho em Configurações) e mostra a URL pronta, para copiar. No banco fica só a CHAVE do
// arquivo no R2 (`e1_imagem`, ex.: img/empresas/logo-1-….png) — é assim que a API pública e os feeds XML a usam.
// Só dá para enviar depois que a empresa existe (o arquivo é gravado na empresa); numa empresa nova, salve primeiro.
export default function LogoEmpresa({ publicId, imagem, url, setCampo, desabilitado }) {
  const toast = useToast();
  const [enviando, setEnviando] = useState(false);
  const [urlAtual, setUrlAtual] = useState(url || '');
  const entrada = useRef(null);

  async function aoEscolher(e) {
    const arquivo = e.target.files?.[0];
    e.target.value = '';
    if (!arquivo) return;
    setEnviando(true);
    try {
      const form = new FormData();
      form.append('logo', arquivo);
      const r = await api.upload(`/empresas/${publicId}/logo`, form);
      setCampo('e1_imagem', r.data.e1_imagem);
      setUrlAtual(r.data.e1_imagem_url || '');
      toast.sucesso('Logo enviado.');
    } catch (err) {
      toast.erro(err.message || 'Não foi possível enviar o logo');
    } finally {
      setEnviando(false);
    }
  }

  async function copiar() {
    try {
      await navigator.clipboard.writeText(urlAtual);
      toast.sucesso('URL copiada.');
    } catch {
      toast.erro('Não consegui copiar. Selecione o endereço e copie manualmente.');
    }
  }

  const temLogo = !!imagem && !!urlAtual;

  return (
    <Form.Group>
      <Form.Label>Logo</Form.Label>
      <div className="d-flex align-items-center gap-3 flex-wrap">
        <div className="border rounded bg-white d-flex align-items-center justify-content-center" style={{ width: 160, height: 90 }}>
          {temLogo ? (
            <img src={urlAtual} alt="Logo da empresa" style={{ maxWidth: '100%', maxHeight: '100%' }} />
          ) : (
            <span className="text-muted small">Sem logo</span>
          )}
        </div>
        <div>
          <input ref={entrada} type="file" accept="image/png,image/jpeg,image/webp" hidden onChange={aoEscolher} />
          <Button variant="outline-primary" size="sm" disabled={desabilitado || enviando || !publicId} onClick={() => entrada.current?.click()}>
            {enviando ? <Spinner animation="border" size="sm" /> : temLogo ? 'Trocar logo' : 'Enviar logo'}
          </Button>
          {temLogo && (
            <Button variant="link" size="sm" className="text-danger" disabled={desabilitado || enviando} onClick={() => { setCampo('e1_imagem', ''); setUrlAtual(''); }}>
              Remover
            </Button>
          )}
          <div className="text-muted small mt-1">
            {publicId ? 'JPG, PNG ou WEBP (limite de tamanho em Configurações). O envio é imediato; "Remover" só vale ao salvar.' : 'Salve a empresa primeiro para poder enviar o logo.'}
          </div>
        </div>
      </div>
      {temLogo && (
        <InputGroup className="mt-2" size="sm">
          <Form.Control readOnly value={urlAtual} onFocus={(e) => e.target.select()} aria-label="URL do logo" />
          <Button variant="outline-secondary" onClick={copiar}>Copiar URL</Button>
        </InputGroup>
      )}
    </Form.Group>
  );
}
